import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
//
import { PATH_DASHBOARD } from './paths';
import AuthGuard from "../guards/AuthGuard";

// ----------------------------------------------------------------------

const DashboardRoutes = {
  path: '*',
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_DASHBOARD.general.pageOne,
      component: lazy(() => import('../views/PageOne'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.pageTwos,
      component: lazy(() => import('../views/PageTwo'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.pageThree,
      component: lazy(() => import('../views/PageThree'))
    },
      {
          exact: true,
          path: PATH_DASHBOARD.general.newBooking,
          component: lazy(() => import('../views/NewBooking'))
      },
    {
      exact: true,
      path: PATH_DASHBOARD.general.timeTablePage,
      component: lazy(() => import('../views/ConfigPage'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.configPage,
      component: lazy(() => import('../views/ConfigPage'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.pastBookings,
      component: lazy(() => import('../views/PastBookings'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.root,
      component: () => <Redirect to={PATH_DASHBOARD.general.pageOne} />
    },

    // APP
    // ----------------------------------------------------------------------
    
    {
      exact: true,
      path: PATH_DASHBOARD.app.root,
      component: () => <Redirect to={PATH_DASHBOARD.app.pageFour} />
    },

    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/app" />
    }
  ]
};

export default DashboardRoutes;
